import { P0, S, abs, arc, dot, fillAt, frac, max, quad } from '../../geometry';

export const flame = {
  name: 'Flame',
  colors: ['#E5484D', '#E3A008'],
  draw(m, t) {
    let fl = 3 * S(t * 2.4),
      h = 0,
      side = 2 * S(t * 3),
      emb = 0,
      rate = 0.7,
      pose = P0();
    if (m === 'happy') {
      fl = 6 * S(t * 9);
      side = 6 * S(t * 12);
      h = -4 * abs(S(t * 6));
      emb = 1;
      rate = 1.4;
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: the flame keeps flickering, tips licking in turn, embers drifting up.
    if (m === 'thinking') {
      fl = 7 * S(t * 3.4) + 2 * S(t * 7.7);
      side = 7 * S(t * 3.4 + 1.6);
      h = -3 * abs(S(t * 2.6));
      emb = 1;
    }
    if (m === 'talking') {
      h = -6 * max(0, S(t * 10));
      fl = 2 * S(t * 5);
    }
    if (m === 'surprised') {
      h = -9;
      fl = 1.5 * S(t * 25);
      side = -4;
    }
    if (m === 'paused') {
      h = 12;
      fl = 3 * S(t * 0.8);
      side = 2;
      pose.ty = 2;
    }
    const MT = [50 + fl, 12 + h],
      RT = [69 + side * 0.3, 34 + side + h * 0.3],
      LT = [31 + side * 0.3, 37 - side + h * 0.3];
    const body = [
      ...arc(50, 64, 21, 180, 0, 13),
      ...quad([71, 64], [74, 50], RT, 5).slice(1),
      [61, 46],
      ...quad([61, 46], [62, 26], MT, 5).slice(1),
      ...quad(MT, [40, 28], [40, 45], 5).slice(1),
      LT,
      ...quad(LT, [26, 50], [29, 64], 5).slice(1),
    ];
    const embers = [0, 1].map((i) => {
      const f = frac(t * rate + i * 0.5),
        x = (i ? 64 : 36) + 4 * S(f * 7 + i * 2) + fl * 0.4,
        y = 30 + h * 0.3 - f * 26;
      return {
        c: 'b',
        pts: dot(x, y),
        o: emb * S(Math.PI * f),
        snap: true,
        detail: true,
      };
    });
    return {
      strokes: [{ c: 'a', pts: body, n: 48, sharp: true }, ...embers],
      eyes: { x: 50, y: 64 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0),
};
